import styled from "@emotion/styled";
import React from "react";
import Meals from "src/ui/components/Meals/Meals";

const PageWrap = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
`;

const MealsPage = () => {
  return (
    <PageWrap>
      <Meals />
    </PageWrap>
  );
};

export default MealsPage;
